
/* injects from baggage-loader */

import React, { useEffect, useState } from "react";
import GameListWrapper from "../gameListWrapper";
import GameNotFound from "../gameNotFound";
import Zergling from "../../../helpers/zergling";

export const BetBuilderSection = ({ gameType, isAsian, regionId, competitionId, sportAlias, child }) => {

    const [betBuilderGameIds, setBetBuliderGameIds] = useState(null)

    useEffect(() => {
        const request = {
            "source": "betting",
            "what": {
                "sport": ["id", "name", "alias", "order"],
                "game": ["id"],
            },

            "where": {
                "sport": { "type": { "@nin": [1, 4] } },
                "game": { "@or": [{ "visible_in_prematch": 1 }, { 'type': { "@in": [0, 2] } }], "sportcast_id": { "@gt": 1 } }

            },
        }

        Zergling.get(request, "get").then((resp) => {
            console.log(resp)
            const sportsList = Object.values(resp.data.sport)
            const gameIds = []
            sportsList.forEach(sport => gameIds.push(...Object.keys(sport.game)))
            setBetBuliderGameIds(gameIds.map(item => +item))
        });
    }, []);

    if (gameType) {
        return (
            <div className={`select-sport-contain-m ${gameType}`}>
                {
                    ((regionId || competitionId) && !child && betBuilderGameIds) ? <GameListWrapper
                        gameType={gameType}
                        isAsian={isAsian}
                        sportAlias={sportAlias}
                        regionId={regionId}
                        betBuilderGameIds={betBuilderGameIds}
                        competitionId={competitionId} /> : child
                }
            </div>
        );
    } else {
        return <GameNotFound />;
    }
}
